import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PdfjsService } from 'src/app/shared/services/pdfjs/pdfjs.service';

@Injectable({
  providedIn: 'root'
})
export class PdfToPngService {

  pdfToPngUrl: string = environment.pdfToPngUri;
  pdfToPngCode: string = environment.pdfToPngKey;

  pdfjs: PdfjsService;

  constructor(private http: HttpClient, pdfjs: PdfjsService) {
    this.pdfjs = pdfjs
   }

  getPngFromPdf(pdfBytes: string) {
    return this.http.post(this.pdfToPngUrl + '?code=' + this.pdfToPngCode, pdfBytes,
      {
        responseType: "text"
      });
  }

  /** Maximum time (ms) allowed for the entire PDF→PNG pipeline before aborting. */
  private static readonly PDF_PROCESSING_TIMEOUT_MS = 30_000;

  async getPngFromPdfjs(pdfBytes: ArrayBuffer, scale: number = 1, maxPages: number | null = null): Promise<string> {
    const timeoutPromise = new Promise<never>((_, reject) =>
      setTimeout(
        () => reject(new Error(`PDF processing timed out after ${PdfToPngService.PDF_PROCESSING_TIMEOUT_MS / 1000}s`)),
        PdfToPngService.PDF_PROCESSING_TIMEOUT_MS
      )
    );

    const pageRange = maxPages !== null
      ? { start: 1, max: maxPages }
      : { start: 1, max: null };

    const result = await Promise.race([
      this.pdfjs.getPdfPages(pdfBytes, pageRange),
      timeoutPromise,
    ]);

    if (result) {
      return (await Promise.race([
        this.pdfjs.stichPdfPagesToSinglePng(result[0], scale),
        timeoutPromise,
      ])).dataUrl;
    }

    return '';
  }
}
